import axios from "axios";
import { DataGrid, FileUploader } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  ColumnFixing,
  Editing,
  Export,
  FilterRow,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Item,
  LoadPanel,
  Lookup,
  Paging,
  Popup,
  Position,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
  Summary,
  Texts,
  Toolbar,
  ToolbarItem,
  TotalItem,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NY } from "../data";
import { init, updateAll } from "./Redux/sae";
import SAEForm from "./SAEForm";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import { notifyMsg } from "../../../common/notify";

export default function SafetyReporting(props) {
  const { sales } = props;

  const SAE = useSelector((state) => state.SAE);

  const dispatch = useDispatch();

  const formSAERef = useRef(null);
  const safetyReportingGridRef = useRef(null);

  const [SAEPopupVisible, setSAEPopupVisible] = useState(false);

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: ["contrNo", "siteNo", "SEQ"],
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sftyRpt/${sales.contrNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sftyRpt/${sales.contrNo}/${values.siteNo}`,
            values
          );
        },
        update: async (key, values) => {
          await axios.put(
            // `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sftyRpt/${sales.contrNo}/${key.siteNo}/${key.SEQ}`,
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sftyRpt/${key.contrNo}/${key.siteNo}/${key.SEQ}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            // `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sftyRpt/${sales.contrNo}/${key.siteNo}/${key.SEQ}`
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sftyRpt/${key.contrNo}/${key.siteNo}/${key.SEQ}`
          );
        },
      })
    );
  }, [sales.contrNo]);

  const onInitNewRow = () => {
    dispatch(init());

    setSAEPopupVisible(true);
  };

  const onEditingStart = (e) => {
    dispatch(updateAll({ ...e.data, action: "update" }));

    setSAEPopupVisible(true);
  };

  const contentRender = useCallback(() => {
    return (
      <SAEForm contrNo={sales.contrNo} SAE={SAE} formSAERef={formSAERef} />
    );
  }, [SAE]);

  const onSaveClick = useCallback(() => {
    if (formSAERef.current.instance.validate().isValid) {
      setSAEPopupVisible(false);

      if (SAE.action == "insert") {
        safetyReportingGridRef.current.instance
          .getDataSource()
          .store()
          .insert(SAE)
          .then(() => {
            safetyReportingGridRef.current.instance.refresh();
          });
      } else {
        safetyReportingGridRef.current.instance
          .getDataSource()
          .store()
          .update(
            {
              contrNo: SAE.contrNo,
              siteNo: SAE.siteNo,
              SEQ: SAE.siteNo,
            },
            SAE
          )
          .then(() => {
            safetyReportingGridRef.current.instance.refresh();
          });
      }
    }
  }, [SAE]);

  const headerCellRender = () => {
    return (
      <div>
        Site Information <br /> (Site No.-Site Name-PI Name)
      </div>
    );
  };

  const calculateCellValue = (data) =>
    `${data.siteNo}-${data.LAB_NAME}-${data.INSPCT_MANAGER_NAME}`;

  const calculateCustomSummary = (options) => {
    if (options.name == "initialFuRptDate") {
      setTotalValue(options, "initialFuRptDate");
    } else if (options.name == "1stFuRptDate") {
      setTotalValue(options, "1stFuRptDate");
    } else if (options.name == "2ndFuRptDate") {
      setTotalValue(options, "2ndFuRptDate");
    } else if (options.name == "3rdFuRptDate") {
      setTotalValue(options, "3rdFuRptDate");
    } else if (options.name == "4thFuRptDate") {
      setTotalValue(options, "4thFuRptDate");
    } else if (options.name == "5thFuRptDate") {
      setTotalValue(options, "5thFuRptDate");
    } else if (options.name == "6thFuRptDate") {
      setTotalValue(options, "6thFuRptDate");
    } else if (options.name == "7thFuRptDate") {
      setTotalValue(options, "7thFuRptDate");
    } else if (options.name == "8thFuRptDate") {
      setTotalValue(options, "8thFuRptDate");
    } else if (options.name == "9thFuRptDate") {
      setTotalValue(options, "9thFuRptDate");
    } else if (options.name == "10thFuRptDate") {
      setTotalValue(options, "10thFuRptDate");
    } else if (options.name == "IRBRpt") {
      if (options.summaryProcess == "start") {
        options.totalValue = 0;
      } else if (options.summaryProcess == "calculate") {
        if (options.value["IRBRpt"] == "Y") {
          options.totalValue++;
        }
      }
    } else if (options.name == "1stIRBRptDate") {
      setTotalValue(options, "1stIRBRptDate");
    } else if (options.name == "2ndIRBRptDate") {
      setTotalValue(options, "2ndIRBRptDate");
    } else if (options.name == "3rdIRBRptDate") {
      setTotalValue(options, "3rdIRBRptDate");
    } else if (options.name == "4thIRBRptDate") {
      setTotalValue(options, "4thIRBRptDate");
    } else if (options.name == "5thIRBRptDate") {
      setTotalValue(options, "5thIRBRptDate");
    }
  };

  const setTotalValue = (options, name) => {
    if (options.summaryProcess == "start") {
      options.totalValue = 0;
    } else if (options.summaryProcess == "calculate") {
      if (options.value[name]) {
        options.totalValue++;
      }
    }
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#A9D08E";

      switch (e.column.dataField) {
        case "fuRptDate.3rd":
        case "fuRptDate.4th":
        case "fuRptDate.5th":
        case "fuRptDate.6th":
        case "tot37CT":
          e.cellElement.style.backgroundColor = "#00B0F0";
          break;
        case "fuRptDate.7th":
        case "fuRptDate.8th":
        case "fuRptDate.9th":
        case "fuRptDate.10th":
        case "tot7CT":
          e.cellElement.style.backgroundColor = "#FFC000";
          break;
        case "IRBRpt":
        case "IRBRptDate.1st":
        case "IRBRptDate.2nd":
        case "IRBRptDate.3rd":
        case "IRBRptDate.4th":
        case "IRBRptDate.5th":
        case "IRBRptTotCT":
        case "IRBRptCmt":
          e.cellElement.style.backgroundColor = "#FFE699";
          break;
      }

      if (e.column.caption == "IRB Reporting") {
        e.cellElement.style.backgroundColor = "#FFE699";
      }
    }
  };

  const onExporting = (e) => {
    safetyReportingGridRef.current.instance.clearFilter();

    e.component.beginUpdate();
    e.component.columnOption("contrNo", "visible", true);
    e.component.columnOption("siteNo", "visible", true);
    e.component.columnOption("SEQ", "visible", true);

    const workbook = new Workbook();

    workbook.creator = "BeTree";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet("Safety Reporting");

    worksheet.properties.defaultRowHeight = 13.5;

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: ({ gridCell, excelCell }) => {
        excelCell.font = {
          size: 10,
        };

        excelCell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        if (gridCell.rowType === "data") {
          switch (gridCell.column.dataField) {
            case "contrNo":
            case "siteNo":
            case "SEQ":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FBFBFBF" },
              };
              break;
          }
        } else if (gridCell.rowType === "header") {
          excelCell.font = {
            bold: true,
            size: 10,
          };

          excelCell.alignment = {
            vertical: "middle",
            horizontal: "center",
          };
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FA9D08E",
            },
          };

          switch (gridCell.column.dataField) {
            case "contrNo":
              worksheet.getColumn(excelCell.col).width = 15;
              break;
            case "siteNo":
            case "SEQ":
              worksheet.getColumn(excelCell.col).width = 7;
              break;
            case "siteInfo":
            case "rptTerm":
              worksheet.getColumn(excelCell.col).width = 50;
              break;
            case "subjectNo":
              worksheet.getColumn(excelCell.col).width = 30;
              break;
            case "cmt":
              worksheet.getColumn(excelCell.col).width = 30;
              break;
            case "fuRptDate.3rd":
            case "fuRptDate.4th":
            case "fuRptDate.5th":
            case "fuRptDate.6th":
            case "tot37CT":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "F00B0F0",
                },
              };

              worksheet.getColumn(excelCell.col).width = 15;
              break;
            case "fuRptDate.7th":
            case "fuRptDate.8th":
            case "fuRptDate.9th":
            case "fuRptDate.10th":
            case "tot7CT":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FFFC000",
                },
              };

              worksheet.getColumn(excelCell.col).width = 15;
              break;
            case "IRBRpt":
            case "IRBRptDate.1st":
            case "IRBRptDate.2nd":
            case "IRBRptDate.3rd":
            case "IRBRptDate.4th":
            case "IRBRptDate.5th":
            case "IRBRptTotCT":
            case "IRBRptCmt":
              excelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "FFFE699",
                },
              };

              worksheet.getColumn(excelCell.col).width = 15;
              break;
            default:
              worksheet.getColumn(excelCell.col).width = 15;
              break;
          }

          if (gridCell.column.caption == "IRB Reporting") {
            excelCell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: {
                argb: "FFFE699",
              },
            };
          }
        }
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], {
            type: "application/octet-stream",
          }),
          `Safety Reporting_${sales.contrNo}.xlsx`
        );
      });

      e.component.columnOption("contrNo", "visible", false);
      e.component.columnOption("siteNo", "visible", false);
      e.component.columnOption("SEQ", "visible", false);
      e.component.endUpdate();

      notifyMsg("Safety Report 파일이 다운로드 되었습니다.", "success");
    });
  };

  return (
    <DataGrid
      id="safetyReportingGrid"
      ref={safetyReportingGridRef}
      dataSource={dataSource}
      allowColumnReordering={true}
      allowColumnResizing={true}
      columnResizingMode="widget"
      rowAlternationEnabled={true}
      showBorders={true}
      showRowLines={true}
      showColumnLines={true}
      width={"100%"}
      height={"100%"}
      repaintChangesOnly={true}
      highlightChanges={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      onInitNewRow={onInitNewRow}
      onEditingStart={onEditingStart}
      onCellPrepared={onCellPrepared}
      onExporting={onExporting}
    >
      <LoadPanel shading={true} />
      {/* <GroupPanel visible={true} /> */}
      <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
      {/* <Grouping autoExpandAll={true} /> */}
      <Scrolling
        mode={"virtual"}
        rowRenderingMode={"virtual"}
        columnRenderingMode={"virtual"}
        showScrollbar={"always"}
      />
      <HeaderFilter visible={true} />
      <FilterRow visible={true} applyFilter={"auto"} />
      <Paging enabled={false} />
      <Sorting mode={"multiple"} />
      <Selection mode={"single"} />
      <ColumnFixing enabled={true} />
      <ColumnChooser height={"340px"} enabled={true} mode={"dragAndDrop"}>
        <Position
          my={"right top"}
          at={"right bottom"}
          of={".dx-datagrid-column-chooser-button"}
        />
      </ColumnChooser>

      <Editing
        refreshMode={"reshape"}
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteMessage={"Are you sure want to delete the SAE log?"}
        />
        <Popup
          visible={SAEPopupVisible}
          showTitle={true}
          title={
            SAE.action == "insert" ? "Create a SAE Log" : "Edit the SAE Log"
          }
          height={"auto"}
          showCloseButton={true}
          contentRender={contentRender}
        >
          <ToolbarItem
            widget={"dxButton"}
            toolbar={"top"}
            location={"after"}
            options={{
              icon: "save",
              type: "normal",
              stylingMode: "contained",
              onClick: onSaveClick,
            }}
          />
        </Popup>
      </Editing>

      <Export enabled={true} />

      <Toolbar>
        {/* <Item location={"before"}>
          <div className="file-uploader-block">
            <FileUploader
              id="IRBFileUploader"
              width={350}
              uploadMode="instantly"
              // uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb?employeeNo=${userInfo.employeeNo}`}
              allowedFileExtensions={[".xlsx"]}
              showFileList={false}
              // onUploadStarted={onUploadStarted}
              // onUploaded={onUploaded}
              // onUploadError={onUploadError}
            />
          </div>
        </Item> */}
        <Item location="after" name={"addRowButton"} />
        <Item name={"exportButton"} />
        <Item name={"columnChooserButton"} />
        <Item name={"searchPanel"} />
      </Toolbar>

      <Column dataField={"contrNo"} caption={"Contract No."} visible={false} />
      <Column dataField={"siteNo"} caption={"Site No."} visible={false} />
      <Column dataField={"SEQ"} caption={"SEQ"} visible={false} />

      <Column
        dataField={"siteInfo"}
        // groupIndex={1}
        dataType={"string"}
        width={400}
        headerCellRender={headerCellRender}
        calculateCellValue={calculateCellValue}
      />
      <Column
        dataField={"subjectNo"}
        caption={"Subject No."}
        dataType={"string"}
      />
      <Column caption={"SAE Log"}>
        <Column
          dataField={"rptTerm"}
          caption={"Reported Term"}
          dataType={"string"}
          width={300}
        />
        <Column
          dataField={"onsetDate"}
          caption={"Onset Date"}
          dataType={"string"}
          width={100}
        />
        <Column dataField={"ongoing"} caption={"Ongoing"} dataType={"string"}>
          <Lookup dataSource={NY} displayExpr={"name"} valueExpr={"id"} />
        </Column>
        <Column
          dataField={"endDate"}
          caption={"End Date"}
          dataType={"string"}
          width={100}
        />
        <Column
          dataField={"fuRptDate.initial"}
          caption={"Initial Report (SAE case)"}
          dataType={"string"}
        />
        <Column caption={"Follow-up Report"}>
          <Column
            dataField={"fuRptDate.1st"}
            caption={"1st"}
            dataType={"string"}
            width={100}
          />
          <Column
            dataField={"fuRptDate.2nd"}
            caption={"2nd"}
            dataType={"string"}
            width={100}
          />
          <Column
            dataField={"fuRptDate.3rd"}
            caption={"3rd"}
            dataType={"string"}
            width={100}
          />
          <Column
            dataField={"fuRptDate.4th"}
            caption={"4th"}
            dataType={"string"}
            width={100}
          />
          <Column
            dataField={"fuRptDate.5th"}
            caption={"5th"}
            dataType={"string"}
            width={100}
          />
          <Column
            dataField={"fuRptDate.6th"}
            caption={"6th"}
            dataType={"string"}
            width={100}
          />
          <Column
            dataField={"fuRptDate.7th"}
            caption={"7th"}
            dataType={"string"}
            width={100}
          />
          <Column
            dataField={"fuRptDate.8th"}
            caption={"8th"}
            dataType={"string"}
            width={100}
          />
          <Column
            dataField={"fuRptDate.9th"}
            caption={"9th"}
            dataType={"string"}
            width={100}
          />
          <Column
            dataField={"fuRptDate.10th"}
            caption={"10th"}
            dataType={"string"}
            width={100}
          />
        </Column>
      </Column>
      <Column dataField={"totCT"} caption={"Total Count"} dataType={"number"} />
      <Column
        dataField={"tot37CT"}
        caption={"3 times or more and less than 7 times"}
        dataType={"number"}
      />
      <Column
        dataField={"tot7CT"}
        caption={"7 times or more"}
        dataType={"number"}
      />
      <Column
        dataField={"cmt"}
        caption={"Comment"}
        dataType={"string"}
        width={300}
      />
      <Column
        dataField={"IRBRpt"}
        caption={"Becco's IRB Reporting"}
        dataType={"string"}
      >
        <Lookup dataSource={NY} displayExpr={"name"} valueExpr={"id"} />
      </Column>
      <Column caption={"IRB Reporting"}>
        <Column
          dataField={"IRBRptDate.1st"}
          caption={"1st"}
          dataType={"string"}
          width={100}
        />
        <Column
          dataField={"IRBRptDate.2nd"}
          caption={"2nd"}
          dataType={"string"}
          width={100}
        />
        <Column
          dataField={"IRBRptDate.3rd"}
          caption={"3rd"}
          dataType={"string"}
          width={100}
        />
        <Column
          dataField={"IRBRptDate.4th"}
          caption={"4th"}
          dataType={"string"}
          width={100}
        />
        <Column
          dataField={"IRBRptDate.5th"}
          caption={"5th"}
          dataType={"string"}
          width={100}
        />
      </Column>
      <Column
        dataField={"IRBRptTotCT"}
        caption={"Total Count"}
        dataType={"number"}
      />
      <Column dataField={"IRBRptCmt"} caption={"Comment"} dataType={"string"} />

      <Summary
      //  calculateCustomSummary={calculateCustomSummary}
      >
        <TotalItem
          name={"initialFuRptDate"}
          showInColumn={"initialFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"1stFuRptDate"}
          showInColumn={"1stFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"2ndFuRptDate"}
          showInColumn={"2ndFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"3rdFuRptDate"}
          showInColumn={"3rdFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"4thFuRptDate"}
          showInColumn={"4thFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"5thFuRptDate"}
          showInColumn={"5thFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"6thFuRptDate"}
          showInColumn={"6thFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"7thFuRptDate"}
          showInColumn={"7thFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"8thFuRptDate"}
          showInColumn={"8thFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"9thFuRptDate"}
          showInColumn={"9thFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"10thFuRptDate"}
          showInColumn={"10thFuRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem column={"totCT"} summaryType={"sum"} displayFormat={"{0}"} />
        <TotalItem
          column={"tot37CT"}
          summaryType={"sum"}
          displayFormat={"{0}"}
        />
        <TotalItem
          column={"tot7CT"}
          summaryType={"sum"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"IRBRpt"}
          showInColumn={"IRBRpt"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"1stIRBRptDate"}
          showInColumn={"1stIRBRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"2ndIRBRptDate"}
          showInColumn={"2ndIRBRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"3rdIRBRptDate"}
          showInColumn={"3rdIRBRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"4thIRBRptDate"}
          showInColumn={"4thIRBRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          name={"5thIRBRptDate"}
          showInColumn={"5thIRBRptDate"}
          summaryType={"custom"}
          displayFormat={"{0}"}
        />
        <TotalItem
          column={"IRBRptTotCT"}
          summaryType={"sum"}
          displayFormat={"{0}"}
        />
      </Summary>
    </DataGrid>
  );
}
